import { z } from "zod";
import { IntegrationType } from "../../../../enum/index";

export const UpdateAiIntegrationFormSchema = z.object({
  name: z
    .string()
    .min(1, { message: "O nome é obrigatório." })
    .max(255, { message: "O nome não pode exceder 255 caracteres." }),

  integration_key: z
    .string()
    .min(1, { message: "A chave da integração é obrigatória." }),

  type: z.nativeEnum(IntegrationType, {
    required_error: "O tipo da integração é obrigatório.",
  }),

  ai_integration_id: z
    .string()
    .min(1, { message: "ID da integração é obrigatório." }),
});

export type UpdateAiIntegrationData = z.infer<
  typeof UpdateAiIntegrationFormSchema
>;
